import React, { useState } from 'react';

const ChatbotContext = React.createContext({
  state: { conversationMessages: [] },
  setState: () => {
  }
});
const ChatbotProvider = ({ children, conversationMessages = [], discussionId, sessionId }) => {
  const [state, setState] = useState({ conversationMessages, discussionId, sessionId });
  return /* @__PURE__ */ React.createElement(
    ChatbotContext.Provider,
    {
      value: {
        state,
        setState
      }
    },
    children
  );
};

export { ChatbotContext, ChatbotProvider };
//# sourceMappingURL=src-contexts-ChatbotContext.js.map
